export const userForbidden = (response) => {
    if (response.status === 403) {
        localStorage.removeItem('token')
    }
}
